<div
	class="insurance-period"
	fxLayout="row"
	fxLayout.sm="column"
	fxLayout.xs="column"
	*ngIf="absence && absence.refEmployee && absence.pkProInsuranceEntryDate"
>
	<span class="insurance-period-label">{{ 'newIncapacityTitle' | translate }}</span> &nbsp;
</div>
